import React from "react";
import './index.scss';
import './fonts.css';
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/globals.css"
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "react-auth-kit";

import { Provider as StyletronProvider } from "styletron-react";
import { Client as Styletron } from "styletron-engine-atomic";
import { LanguageProvider } from './lib/language-context'
import { StoreConfigProvider } from './lib/store-config-context'

import {
  LightTheme,
  BaseProvider,
  styled,
  DarkTheme,
  createDarkTheme,
} from "baseui";

import 'normalize.css';
import './utils/browserSupport.js';
import './utils/preloadFonts.js';
//import './editor.js';

const engine = new Styletron();

const Centered = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

declare global {
  interface Window {
    token: string;
    is_iframe: boolean;
    checkedLog: boolean;
    totalQuota: string;
    is_catalog: boolean;
    is_model_register: boolean;
  }
}

root.render(
  <React.StrictMode>
    <StyletronProvider value={engine}>
      <BaseProvider
        theme={DarkTheme}
        overrides={{
          AppContainer: { style: { width: "100%", height: "100%" } },
        }}
      >
        <AuthProvider
          authType={"cookie"}
          authName={"_auth"}
          cookieDomain={window.location.hostname}
          cookieSecure={false}
        >
          <Centered>
            <BrowserRouter>
              <LanguageProvider>
                <StoreConfigProvider>
                  <App />
                </StoreConfigProvider>
              </LanguageProvider>

            </BrowserRouter>
          </Centered>
        </AuthProvider>
      </BaseProvider>
    </StyletronProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
